<template>
  <div class="ei-back-head-info" v-on:mouseleave="onHandleHeadInfoMouseLeave">
    <div class="head" v-on:mouseenter="onHandleHeadMouseEnter" :style="{'--zIndex':zIndex}">
      <img v-if="info.imgurl" :class="{'head-img':true,'active':active}" :src="info.imgurl" alt="head" :style="{'--size':size+'px'}">
      <span v-else :class="{'head-img iconfont icon-geren':true,'active':active}" alt="head" :style="{'--size':size+'px'}"></span>
    </div>
    <div :class="{'info':true,'active':active,'none':none}" :style="{'--zIndex':zIndex-1}">
      <div class="nickname"><h3>{{ info.nickname }}</h3></div>
      <div class="horizontal-line"></div>
      <div class="links">
        <div class="link" @click="$router.push('/profile')">
          <span class="iconfont icon-geren"></span>
          个人中心
        </div>
        <div class="link" @click="$router.push('/home')">
          <span class="iconfont icon-pingtai"></span>
          前往首页
        </div>
        <div class="link">
          <span class="iconfont icon-dingdan"></span>
          我的订单
        </div>
        <div class="link">
          <span class="iconfont icon-qianbao"></span>
          我的钱包
        </div>
      </div>
      <div class="horizontal-line"></div>
      <div class="logout" @click="onHandleLogoutClick">
        <span class="iconfont icon-tuichu"></span>
        退出
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EiBackHeadInfo",
  props: {
    info: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 42,
    },
    zIndex: {
      type: Number,
      default: 999,
    }
  },
  data() {
    return {
      active: false,
      none: true
    }
  },
  methods: {
    onHandleHeadMouseEnter() {
      setTimeout(() => {
        this.none = false
        setTimeout(() => {
          this.active = true
        }, 100)
      }, 100)
    },
    onHandleHeadInfoMouseLeave() {
      setTimeout(() => {
        this.active = false
        setTimeout(() => {
          this.none = true
        }, 100)
      }, 300)
    },
    onHandleLogoutClick() {
      this.$emit("onHandleLogoutClick")
    }
  }
}
</script>

<style scoped lang="scss">
@import "css/ei-common";
.ei-back-head-info {
  width: 250px;
  height: auto;
  color: #212121;

  .head {
    vertical-align: top;
    z-index: var(--zIndex);
    position: relative;

    .head-img {
      display: block;
      margin: 0 auto;
      width: var(--size);
      height: var(--size);
      border-radius: 50%;
      transition: all .2s ease-out;
      cursor: pointer;
      background-color: #F4F4F5;
      text-align: center;
      line-height: var(--size);
      font-size: 25px;
    }

    .head-img.active {
      transform: scale(1.5) translate(0, 10px);
      transition: all .2s ease-out;
    }
  }

  .info {
    position: relative;
    display: block;
    opacity: 0;
    width: 250px;
    margin: 0 auto;
    padding: 35px 0 15px 0;
    background-color: #fff;
    border-radius: 5px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    pointer-events: none;
    z-index: -1;


    &.active {
      opacity: 1;
      z-index: var(--zIndex);
      transition: all 0.1s ease;
      pointer-events: all;
    }

    .nickname {
      text-align: center;
    }

    .counts {
      width: 100%;
      display: flex;
      justify-content: space-evenly;

      .kv {
        text-align: center;
        cursor: pointer;

        h3 {
          transition: all .2s ease-out;
        }

        &:hover h3 {
          color: #DA0C30;
          transition: all .2s ease-out;
        }

        p {
          margin-top: 3px;
          color: #8c939d;
          transition: all .2s ease-out;
        }

        &:hover p {
          color: #DA0C30;
          transition: all .2s ease-out;
        }
      }
    }

    .links {
      line-height: 45px;

      .link {
        cursor: pointer;
        transition: all .2s ease-out;

        span {
          margin-left: 20px;
        }

        &:hover {
          color: #DA0C30;
          background-color: #F0F0F5;
          transition: all .2s ease-out;
        }
      }
    }

    .logout {
      cursor: pointer;
      transition: all .2s ease-out;
      width: 80px;

      &:hover {
        color: #DA0C30;
        transition: all .2s ease-out;
      }

      span {
        margin-left: 20px;
      }
    }
  }
}

.horizontal-line {
  margin: 20px 0 10px 0;
  border-bottom: 1px solid rgb(139, 148, 159, 0.2);
}
</style>
